import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { Department } from "./configTypes";

export default function useDepartments() {
    const [departments, setDepartments] = useState<Department[]>([]);

    const getDepartments = async () => {
        const res = await apiClient.get(`/inventory-dev/departments`);
        setDepartments(res.data);
    };

    useEffect(() => {
        getDepartments();
    }, []);

    const createDepartment = async (name: string, code?: string) => {
        const res = await apiClient.post(`/inventory-dev/departments`, { name, code });
        setDepartments((prev) => [...prev, res.data]);
        return res.data as Department;
    };

    const deleteDepartment = async (id: number) => {
        await apiClient.delete(`/inventory-dev/departments/${id}`);
        setDepartments((prev) => prev.filter((d) => d.id !== id));
    };

    return { departments, getDepartments, createDepartment, deleteDepartment };
}
